import type {
  BalancesMapperT,
  GetAllBalancesResponseT,
} from "../types/balances.types";
import type {
  BalanceEntityT,
  GetAllBalancesResultT,
} from "../../domain/entities/balance.entity";
import type { BalanceResponseDtoT } from "../../domain/dtos/balance.dto";

const mapBalanceToDomain = (dto: BalanceResponseDtoT): BalanceEntityT => ({
  collaborator: {
    collaboratorId: dto.collaborator.collaborator_id,
    code: dto.collaborator.code,
    fullName: dto.collaborator.full_name,
    status: dto.collaborator.status,
    seniorityDate: dto.collaborator.seniority_date,
  },
  balances: (dto.balances ?? []).map((item) => ({
    typeId: item.type_id,
    totalEarnedDays: item.total_earned_days,
    totalAccruedDays: item.total_accrued_days,
    totalProportionalDays: item.total_proportional_days_always,
    totalTakenDays: item.total_taken_days,
    totalPendingDays: item.total_pending_days,
    totalAvailableDays: item.total_available_days,
    totalBonusEarnedDays: item.total_bonus_earned_days,
    totalBonusTakenDays: item.total_bonus_taken_days,
    expirationDate: item.expiration_date,
    accruals: item.accruals
      ? item.accruals.map((accrual) => ({
          accrualDate: accrual.accrual_date,
          accruedDays: accrual.accrued_days,
          availableDays: accrual.available_days,
          bonusDays: accrual.bonus_days,
          expirationDate: accrual.expiration_date,
          expiredDays: accrual.expired_days,
          takenDays: accrual.taken_days,
        }))
      : null,
  })),
});


export const balancesMapper: BalancesMapperT = {
  balancesDtoToDomain: (
    rawData: GetAllBalancesResponseT,
  ): GetAllBalancesResultT => ({
    data: (rawData?.data?.collaborators ?? []).map(mapBalanceToDomain),
    meta: {
      page: rawData?.data?.meta?.page ?? 0,
      pageSize: rawData?.data?.meta?.page_size ?? 0,
      totalItems: rawData?.data?.meta?.total_items ?? 0,
      totalPages: rawData?.data?.meta?.total_pages ?? 0,
    },
  }),
};
